export default __webpack_public_path__ + "images/models/83e02de34234e9da219cee09641fbead.usdz";